import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';
import {StatusBadge} from 'shells/status-badge/status-badge';

import {useGetUserSso} from './graphql/hooks';

type Props = {
    userId: string;
};

export function DirectorySyncSetup(props: Props) {
    const {user} = useGetUserSso(props.userId);

    if (!user) {
        return null;
    }

    return (
        <StackLegacy spacing={8}>
            {user.sso.isNutshellManaged ? (
                <StatusBadge
                    level='warning--grey'
                    text='This user is not in your Directory sync'
                    includeIcon={true}
                    isInteractive={false}
                />
            ) : (
                <StatusBadge
                    level='info--grey'
                    text='This user is managed by your Directory sync'
                    isInteractive={false}
                />
            )}
            <Link variant='primary' href='/setup/security'>
                Edit your Directory sync settings
            </Link>
        </StackLegacy>
    );
}
